import style from "./CategoryBookCardView.module.css";

import useWindowSize from "../../../utils/useWindowSize";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
const CategoryBookCardView = ({ props }: any) => {
    const navigate = useNavigate();
    const handleEditCallBack = () => {};

    const { width, height } = useWindowSize();
    const { i18n } = useTranslation();
    const OpenCC = require("opencc-js");
    const converter = OpenCC.Converter({ from: "hk", to: "cn" });

    return (
        <>
            <div className={width <= 768 ? style.TableCardViewContainer2 : style.TableCardViewContainer} onClick={() => navigate("/product/" + props.productId)}>
                <div className={style.TableCardViewContent}>
                    <div>
                        <h5> {i18n.language === "cn" ? converter(props.productNameChi) : props.productNameChi}</h5>
                    </div>
                    <div style={{ fontSize: "12px" }}>{i18n.language === "cn" ? converter(props.author) : props.author}</div>
                    <div className={style.content}>{i18n.language === "cn" ? converter(props.productDescription) : props.productDescription}</div>
                </div>

                <div className={style.TableCardView_IMG}>
                    <img src={process.env.REACT_APP_BACKEND + "/file/" + props.coverFileName} />
                </div>
            </div>
        </>
    );
};

export default CategoryBookCardView;
